import React from 'react';

import FixedHeader from '../../fixed-header/fixed-header';
import HeaderLogo from '../header-logo/header-logo';
import { HeaderMenu } from '../header-menu/header-menu';
import { UserProfileContainer } from '../user-profile/user-profile';

import styles from './main-header.scss';

export const MainHeader = () => {
  return (
    <FixedHeader>
      <div className={styles.headerContent}>
        <HeaderLogo />

        <div className={styles.account}>
          <HeaderMenu />

          <UserProfileContainer className={styles.userProfile} />
        </div>
      </div>
    </FixedHeader>
  );
};
